module.exports = __webpack_public_path__ + "static/media/038.2fc3766c.jpg";